export default __webpack_public_path__ + "locales/cs/People.json?hash=78d68b16d36dec6bd46c58514ecf8a49";